import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styles from './pulse.module.css';

export const PulseLine = ({ text = '', loading = false }) => {
  if (loading) return <Skeleton width={320} height={16} />;
  if (!text) return null;
  return <p className={styles.pulse}>{text}</p>;
};
